import { useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { InstrumentTypeResponse } from "../../../codegen-api";
import { APIEndpointEnum } from "../../../enums/endpoint";
import { PositionHistoryItem } from "../../../interfaces/history";
import { AssetResponse } from "../../../utils/asset";
import {
  useCursorPaginatedHistory,
  UseCursorPaginatedHistoryResult,
} from "./useCursorPaginatedHistory";

interface UsePositionHistoryOptions {
  pageSize?: number;
  instrumentType?: InstrumentTypeResponse;
  /** Server-side filter — only history for this underlying asset. */
  asset?: AssetResponse;
  enabled?: boolean;
}

export const usePositionHistory = ({
  pageSize,
  instrumentType,
  asset,
  enabled = true,
}: UsePositionHistoryOptions = {}): UseCursorPaginatedHistoryResult<PositionHistoryItem> => {
  const { account } = useContext(AuthContext);
  const accountKey = account?.toLowerCase();

  const realtimeChannels = useMemo(
    () => (accountKey ? [`position-history:${accountKey}`] : []),
    [accountKey]
  );

  return useCursorPaginatedHistory<PositionHistoryItem>({
    endpoint: APIEndpointEnum.POSITION_HISTORY,
    itemsKey: "position_history",
    pageSize,
    enabled,
    query: { instrument_type: instrumentType, asset },
    realtimeChannels,
  });
};
